$shm_hitalama_agent_general $shm_hitalama_agent_map_chat
	map_id \
	project_id \
